import React, { useState, useEffect } from "react";
import axios from "axios";

function LaptopForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  // Debug logging
  useEffect(() => {
    console.log('💻 LaptopForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for laptops...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value
    });
  };

  const handleBooleanChange = (e) => {
    const { name, value } = e.target;
    const boolValue = value === "true";
    
    console.log(`✅ Boolean field changed: ${name} = ${boolValue}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: boolValue
    });
  };

  return (
    <div className="laptopForm">
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Laptop istehsalçısı">ℹ️</span>
        </h3>
        <select name="brandId" onChange={handleBrandChange} defaultValue="" disabled={filteredBrands.length === 0}>
          <option value="" disabled>{filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}</option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Laptop modeli">ℹ️</span>
        </h3>
        <select name="modelId" onChange={handleChange} disabled={filteredModels.length === 0} defaultValue="">
          <option value="" disabled>{selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}</option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Yaddaş (GB) <span>*</span>
          <span className="tooltip-icon" title="SSD/HDD həcmi">ℹ️</span>
        </h3>
        <select name="storage" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="128">128 GB</option>
          <option value="256">256 GB</option>
          <option value="512">512 GB</option>
          <option value="1024">1 TB</option>
          <option value="2048">2 TB</option>
        </select>
      </div>

      <div>
        <h3>
          Yaddaş Növü <span>*</span>
          <span className="tooltip-icon" title="SSD daha sürətlidir">ℹ️</span>
        </h3>
        <select name="storageType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="HDD">HDD (Hard Disk)</option>
          <option value="SSD">SSD (Solid State)</option>
          <option value="NVMe SSD">NVMe SSD (Ən sürətli)</option>
        </select>
      </div>

      <div>
        <h3>
          RAM (GB) <span>*</span>
          <span className="tooltip-icon" title="Operativ yaddaş">ℹ️</span>
        </h3>
        <select name="ram" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="4">4 GB</option>
          <option value="8">8 GB</option>
          <option value="16">16 GB</option>
          <option value="32">32 GB</option>
          <option value="64">64 GB</option>
        </select>
      </div>

      <div>
        <h3>
          Əməliyyat sistemi <span>*</span>
          <span className="tooltip-icon" title="OS">ℹ️</span>
        </h3>
        <select name="operatingSystem" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Windows">Windows 11 / 10</option>
          <option value="macOS">macOS (MacBook)</option>
          <option value="Linux">Linux (Ubuntu, Fedora...)</option>
          <option value="DOS">DOS / FreeDOS</option>
        </select>
      </div>

      <div>
        <h3>
          Ekran ölçüsü (inch) <span>*</span>
          <span className="tooltip-icon" title="Diaqonal ölçü">ℹ️</span>
        </h3>
        <select name="screenSize" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="13.3">13.3"</option>
          <option value="14">14"</option>
          <option value="15.6">15.6"</option>
          <option value="16">16"</option>
          <option value="17.3">17.3"</option>
        </select>
      </div>

      <div>
        <h3>
          Prosessor <span>*</span>
          <span className="tooltip-icon" title="CPU modeli">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="processor" 
          placeholder="Intel Core i7-12700H"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Video kart (GPU) <span>*</span>
          <span className="tooltip-icon" title="Graphics card">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="gpu" 
          placeholder="NVIDIA RTX 3060"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Sensor ekran <span>*</span>
          <span className="tooltip-icon" title="Touchscreen">ℹ️</span>
        </h3>
        <select name="hasTouchScreen" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          İşıqlı klaviatura <span>*</span>
          <span className="tooltip-icon" title="Backlit keyboard">ℹ️</span>
        </h3>
        <select name="hasBacklitKeyboard" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Barmaq izi oxuyucu <span>*</span>
          <span className="tooltip-icon" title="Fingerprint reader">ℹ️</span>
        </h3>
        <select name="hasFingerprintReader" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Web kamera <span>*</span>
          <span className="tooltip-icon" title="Daxili kamera">ℹ️</span>
        </h3>
        <select name="hasWebcam" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Çözünürlük <span>*</span>
          <span className="tooltip-icon" title="Ekran çözünürlüyü">ℹ️</span>
        </h3>
        <select name="resolution" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1366x768">HD (1366x768)</option>
          <option value="1920x1080">Full HD (1920x1080)</option>
          <option value="2560x1440">QHD (2560x1440)</option>
          <option value="3840x2160">4K (3840x2160)</option>
        </select>
      </div>

      <div>
        <h3>
          Yenilənmə tezliyi (Hz) <span>*</span>
          <span className="tooltip-icon" title="Refresh rate">ℹ️</span>
        </h3>
        <select name="refreshRate" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="60">60 Hz</option>
          <option value="90">90 Hz</option>
          <option value="120">120 Hz</option>
          <option value="144">144 Hz</option>
          <option value="165">165 Hz</option>
          <option value="240">240 Hz</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Korpus rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Gümüşü, Qara, Ağ..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Çəki (kg) <span>*</span>
          <span className="tooltip-icon" title="Laptopun çəkisi">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="weight" 
          step="0.1" 
          placeholder="1.8"
          min="0.5"
          max="5"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Zəmanət <span>*</span>
          <span className="tooltip-icon" title="Rəsmi zəmanət">ℹ️</span>
        </h3>
        <select name="hasWarranty" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, zəmanətli ✅</option>
          <option value="false">Xeyr, zəmanətsiz ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Laptopun fiziki vəziyyəti">ℹ️</span>
        </h3>
        <select name="condition" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yeni">Yeni (Qutuda)</option>
          <option value="İşlənmiş">İşlənmiş (Yaxşı)</option>
          <option value="Orta">Orta vəziyyət</option>
          <option value="Təmirə ehtiyac">Təmirə ehtiyac var</option>
        </select>
      </div>
    </div>
  );
}

export default LaptopForm;